import { render } from "./BasicComponents.vue?vue&type=template&id=731ca878"
import script from "./BasicComponents.vue?vue&type=script&lang=js"
export * from "./BasicComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__